import {  createSlice } from "@reduxjs/toolkit";

const initialState = {
    adminUserData: null,
};


export const adminUserSlice = createSlice({
    name: "adminUserSlice",
    initialState,
    reducers: {
      setAdminUserDetails: (state, { payload }) => {
          state.adminUserData = payload;
        },
        clearAdminUserDetails: (state) => {
          state.adminUserData = initialState.adminUserData;
        },
    },
    extraReducers(builder){}
  });

export const { setAdminUserDetails,clearAdminUserDetails } = adminUserSlice.actions;


export default adminUserSlice.reducer;
